var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-submenu',{ref:"subMenu",attrs:{"index":_vm.item.path,"popper-append-to-body":false}},[_c('template',{slot:"title"},[(_vm.item.icon)?_c('i',{class:_vm.item.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.item.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }